module.exports = __webpack_public_path__ + "img/icon-property.abd75f4f.svg";